import { Component, OnInit } from "@angular/core";
import { FieldType } from "@kre-form/core";
import { KreFormFieldIonSelectComponent } from "../components/select_component";
import { KreFormIonDialogService } from "../tools/dialog.service";

@Component({
  selector: "kreform-field-ion-checkboxgroup",
  template: `
    <ng-container *ngIf="!!editor; else other">
      <ion-item detail="true" (click)="openPicker()">
        <div>{{ textLookUp }}</div>
      </ion-item>
    </ng-container>
    <ng-template #other>
      <div class="fieldtext">{{ textLookUp }}</div>
    </ng-template>
  `,
})
export class KreFormFieldIonCheckboxGroup extends FieldType {
  constructor(public dialogService: KreFormIonDialogService) {
    super();
  }

  openPicker() {
    let options = [];
    this.to.options.forEach((item: any) => {
      options.push({
        value: item.value,
        label: item.label,
        checked: this.isOptionChecked(item.value),
      });
    });
    let params = {
      options: options,
      selectType: "multiple",
    };
    this.dialogService.CreateModelDialog(
      {
        content: KreFormFieldIonSelectComponent,
        class: "part-page",
      },
      params,
      (instance: any) => {
        if (instance) {
          this.formControl.patchValue(instance);
          this.formControl.markAsTouched();
        }
      }
    );
  }
}
